import React, { useState, useEffect,} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BaseURL, uniqueToken } from '../../api/DataApis';
import { GpsBaseURL, Role } from '../../api/DataApis';
import { Link, Navigate, useParams } from 'react-router-dom';
import request from '../../Apis/request';
import "./User.css";
import ReactPaginate from 'react-paginate'; 
import { GrTransaction } from 'react-icons/gr';
import Loader from "../Settings/Loader";
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { LuUser } from 'react-icons/lu';
import { getCorporateList, getAdminList } from '../../Apis/Setting';

  const Admin = () => {
  const [corporateData, setCorporateData] = useState([]);
  const [selectedCorporate, setSelectedCorporate] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [totalCount, setTotalCount] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatusType, setSelectedStatusType] = useState("0");
  const [userStatuses, setUserStatuses] = useState({});
  const [page, setPage] = useState(1); // State for current page
  const [pageCount, setPageCount] = useState(0); 
  const [popupInput, setPopupInput] = useState('');
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [Limit, setLimit] = useState({});
  const [currentPage, setCurrentPage] = useState(1); 
  const [selectStatusType, setselectedStatusType] = useState("");
  const [searchTerms, setSearchTerms] = useState({
    srNo: '',
    name: '',
    email: '',
    phone: '',
    meterTransactions: '',
    rfids: '',
    wallet: '',
    status: '',
    createdDate: '',
    actions: ''
  });

  let navigate = useNavigate();
  const handleSearch = (column, value) => {
    setSearchTerms((prev) => ({
      ...prev,
      [column]: value
    }));
  };

  const handleReset = (event) => {
    event.preventDefault()
   navigate(`/admin/list`);
    }
 
    const corporateOptions = corporateData.map(corporate => ({
      value: corporate._id,
      label: `${corporate.corporate_name} (${corporate?.email})`,
      _id: corporate._id,
    }));
 document.title = "Admin";
  const handlecorporateChange = (selectedOption) => {
    console.log("selectedOption:", selectedOption);
    
    if (selectedOption) {
      setSelectedCorporate(selectedOption._id);
    } else {
      setSelectedCorporate(null); // Reset state when cleared
    }
  };
  console.log("selectedCorporate", selectedCorporate);
const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
 const fetchCorporate = async () => {
          try {
            const corporatesData = await getCorporateList();
            console.log("corporateData", corporatesData);
            setCorporateData(corporatesData?.data || []);
          } catch (error) {
            console.error("Error fetching classes:", error);
          }
        };
        useEffect(() => {
          if (Role === "false") {
            fetchCorporate();  // Only fetch corporate data if Role === "false"
          }
        }, [Role]);

      
          const getAdmins = async () => {
            setLoadings(true);
            try {
              const data = await getAdminList({
                page,
                searchQuery,
                selectStatusType,
                selectedCorporate,
                uniqueToken,
                GpsBaseURL,
              });
      
              setFilteredData(data?.data);
              setTotalCount(data?.count || 0);
              setLimit(data?.limit);
              setPageCount(Math.ceil(data.count / data?.limit));
            } catch (error) {
              console.error("Failed to fetch users:", error);
            } finally {
              setLoadings(false);
            }
          };
          useEffect(() => {
          getAdmins();
        }, [ page]);
  


  const handleChange = (setter) => (event) => {
    setter(event.target.value);
  };
  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };
const handleSearchTextChange = (e) => {
  setSearchQuery(e.target.value);
};

   const handleSearchSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission
  
    if (!searchQuery.trim()) {
      // If no search query, fetch all data
      await getAdmins(); 
      return;
    }
  
    setPage(1); // Reset to the first page when searching
    setLoadings(true); // Start loading spinner
  
    try {
      const response = await getAdminList({
     page: 1, // Always reset to page 1 when searching
        searchQuery,
      selectedCorporate,
      });
  
      if (response && response.data) {
        setFilteredData(response?.data); // Update filtered data
        setTotalCount(response?.data?.length); // Set total count based on the filtered data length
        setPageCount(Math.ceil(response?.totalCount / Limit));
      } else {
        setFilteredData([]); // If no data is returned, set filtered data to empty
      }
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    } finally {
      setLoadings(false); // Stop loading spinner
    }
  };

  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
            <div className="portlet-body mx-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
  <div className="d-flex align-items-center">
    <h4 className="mb-0 me-3">Admin({totalCount ? totalCount : "Loading..." })</h4> {/* Add margin to the right of the heading */}
   
  </div>
  
  <Link
    className="btn btn-transparent grey-salsa btn-outline btn-sm"
    style={{
      border: "1px solid black",
      borderRadius: "34px",
      display: "inline-flex",
      alignItems: "center",
      overflow: "hidden",
    }}
    to="/admin/add"
  >
    <i className="fa fa-plus"></i> Add Admin
  </Link>
</div>
<hr style={{ marginTop: "0px" }} />
<div className="row">
  <form className="form-horizontal" role="form" style={{ marginTop: "5px" }}>
    <div
      className="row px-3"
      style={{
        display: "flex",
        alignItems: "center",
        //gap: "10px", // Consistent spacing between filters
        flexWrap: "wrap", // Allow wrapping on smaller screens
      }}
    >
<div className="col-md-2 col-sm-12">
  <div className="form-group">
  <input
    placeholder="Find Data Here"
    className="form-control"
    style={{
      //width: "calc(100% - 150px)", // Increased available width for the input box
      borderRadius: "8px",
      padding: "6px 10px",
      marginRight: "10px",
      height: "38px", // Consistent height
    }}
    value={searchQuery}
    onChange={handleSearchTextChange}
  />
  </div>
</div>
{Role === "false" && (
<div className="col-md-2 col-sm-12"style={{alignItems: "center"}}>
  <div className="form-group">
    <Select
      options={corporateOptions}
      onChange={handlecorporateChange}
      value={corporateOptions?.find(option => option.value === selectedCorporate) || ""}
      placeholder="Corporate"
      isClearable
    
      styles={{
        control: (base) => ({
          ...base,
          height: '38px', 
          width: '100%', // Make width responsive
          boxShadow: 'none',
          minWidth: '0', // Ensures it can shrink below 165px if needed
          flex: 1, // Allow select to grow and shrink
        }),
      }}
    />
  </div>
</div>
)}





<div className="col-md-2 col-sm-12" style={{ display: "flex", alignItems: "center" }}>

    {/* Search Button */}
    <button
      className="btn btn-primary"
      onClick={handleSearchSubmit} // Calls the handleSearchSubmit function
      style={{
        marginLeft: "10px", // Space between the input and button
        height: "38px", // Consistent height
        width: "80px", // Consistent width for the Search button
        display: "flex", // Enable flexbox for centering
        justifyContent: "center", // Center horizontally
        alignItems: "center", // Center vertically
        padding: 0, // Ensure no extra padding that could offset centering
      }}
    >
      Search
    </button>

    {/* Reset Button */}
    <button
      className="btn btn-primary"
      onClick={handleReset} // Calls the handleReset function
      style={{
        marginLeft: "10px", // Space between the buttons
        height: "38px", // Consistent height
        width: "80px", // Slightly smaller width for Reset button
        display: "flex", // Enable flexbox for centering
        justifyContent: "center", // Center horizontally
        alignItems: "center", // Center vertically
        padding: 0, // Ensure no extra padding that could offset centering
      }}
    >
      Reset
    </button>

</div>

    </div>
  </form>
</div>



              <div className="card-body" style={{ marginLeft: "-19px" }}>
  {loadings ? (
    <Loader /> 
  ) : totalCount === 0 ? (
    <div className="text-center">
      <h5>No User Data Found</h5> {/* Message to indicate no data found */}
    </div>
  ) : (
    <>
    <div className="table-responsive">
      <table
        className="display dataTable"
        id="advance-1"
        style={{ tableLayout: 'auto', width: '100%', borderCollapse: 'collapse' }}
      >
       <thead>
  <tr>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Sr No</th>
  
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Admin Image</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Name</th>
    {Role === "false" && (
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Corporate Name</th>
  )}
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Phone Code</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Phone No</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Email</th>
 
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Created Date</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Created By</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Updated By</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Action</th>
 
  </tr>
</thead>

        <tbody>
          {filteredData?.map((user, index) => (
            <tr key={index}>
              <td>{(page - 1) * Limit + index + 1}</td>
 
<td>
  {user?.admin_image ? (
    <img src={user?.admin_image} alt="Admin image" style={{ width: '45px', height: 'auto' }} />
  ) : (
    <LuUser/>
  )}
</td>
       <td>{user?.name}</td>
       {Role === "false" &&  (
       <td>{user?.corporate_name}</td>
       )}
       <td>{user?.phone_code}</td>
       <td>{user?.phone}</td>
       <td>{user?.email}</td>
   <td>{user?.created_date}</td>
   <td>{user?.created_by}</td>
   <td>{user?.updated_by}</td>
   
             
   
            
            
              <td style={{ whiteSpace: 'nowrap' }}>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Link to={`/admin/edit/${user?._id}`} state={{ CorporateEditData: user }}>
                  <i className="fa fa-edit"
                   title="Edit User"
                  ></i>
                </Link>
                &nbsp;&nbsp;&nbsp;
                <Link to={`/admin/view/${user?._id}`} state={{ UserViewData: user }}>
                  <i className="fa fa-eye"
                   title="View User"
                  ></i>

                </Link>
                &nbsp;&nbsp;
           </td>               
            </tr>
          ))}   
        </tbody>
      </table>
</div>
    <div className="pagination-container mt-4">
        <ReactPaginate
          previousLabel={'Previous'}
          nextLabel={'Next'}
          breakLabel={'...'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
          forcePage={page - 1} 
        />
      </div>
    </>
  )}
</div>

 </div>
      </div>
    </div>
  </div>
</div>
  );
};

export default Admin;
